import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex flex-wrap justify-content-center align-items-center mt-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_content_loader = _resolveComponent("content-loader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_content_loader, {
      class: "mb-3 me-2",
      width: "275",
      height: "150"
    }),
    _createVNode(_component_content_loader, {
      class: "mb-3 me-2",
      width: "275",
      height: "150"
    }),
    _createVNode(_component_content_loader, {
      class: "mb-3 me-2",
      width: "275",
      height: "150"
    }),
    _createVNode(_component_content_loader, {
      class: "mb-3 me-2",
      width: "275",
      height: "150"
    }),
    _createVNode(_component_content_loader, {
      class: "mb-3 me-2",
      width: "275",
      height: "150"
    }),
    _createVNode(_component_content_loader, {
      class: "mb-3 me-2",
      width: "275",
      height: "150"
    }),
    _createVNode(_component_content_loader, {
      class: "mb-3 me-2",
      width: "275",
      height: "150"
    }),
    _createVNode(_component_content_loader, {
      class: "mb-3 me-2",
      width: "275",
      height: "150"
    }),
    _createVNode(_component_content_loader, {
      class: "mb-3 me-2",
      width: "275",
      height: "150"
    })
  ]))
}